<template>
  <span>
    <div class="page-level-functions">
      <action-button variant="success float-right ml-3" text="Guardar" i="fas fa-save" @click="onClickSaveHandler"/>
      <action-button variant="outline-success float-right ml-3" text="Regresar" i="fas fa-arrow-circle-left" @click="onClickReturnHandler"/>
    </div>

    <hr class="page-level-functions-separator" />

    <section-title content="Añadir Información de Navegación" icon="fas fa-user"/>

    <validation-observer ref="interfaceRef">

      <div class="my-3"> 
        <div class="row">
          <div class="col-md-1">
            <validation-provider :rules="'required'" v-slot="{ errors }">
              <custom-input
                :label="txtOrder.label"
                :type="txtOrder.type"
                :error="errors[0]"
                :custom-error-msg="txtOrder.errorMsg"
                v-model="txtOrder.model"
              />
            </validation-provider>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-input
                  :label="txtName.label"
                  :type="txtName.type"
                  :error="errors[0]"
                  :custom-error-msg="txtName.errorMsg"
                  v-model="txtName.model"
                />
              </validation-provider>
            </div>
          </div>
          <div class="col-md-6">
            <validation-provider :rules="'required'" v-slot="{ errors }">
              <custom-input
                :label="txtDescription.label"
                :type="txtDescription.type"
                :error="errors[0]"
                :custom-error-msg="txtDescription.errorMsg"
                v-model="txtDescription.model"
              />
            </validation-provider>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <validation-provider :rules="'required'" v-slot="{ errors }">
              <custom-input
                :label="txtDetail.label"
                :type="txtDetail.type"
                :error="errors[0]"
                :custom-error-msg="txtDetail.errorMsg"
                v-model="txtDetail.model"
              />
            </validation-provider>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col">
            <div class="form-group">
              <custom-input-display
                :label="txtApplication.label"
                label-class="data-label"
                v-model="txtApplication.model"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <custom-input-display
                :label="txtModule.label"
                label-class="data-label"
                v-model="txtModule.model"
              />
            </div>
          </div>
           <div class="col" v-if="txtUrl.visible">
            <div class="form-group">
              <custom-input-display
                :label="txtUrl.label"
                label-class="data-label"
                v-model="txtUrl.model"
              />
            </div>
          </div>
          <div class="col" v-if="txtIcon.visible">
            <div class="form-group">
              <div v-if="txtIcon.model">
                <label for="" class="data-label">{{txtIcon.label}}</label>
                <div class="mt-n2">
                  <i :class="txtIcon.model + ' ab-btn-outline-success'" aria-hidden="true"></i>
                </div>
              </div>
              <div v-else>
                <custom-input-display 
                  :label="txtIcon.label"
                  label-class="data-label"
                />
              </div>
            </div>
          </div>
          <div class="col" v-if="txtPermission.visible">
            <div class="form-group">
              <custom-input-display
                :label="txtPermission.label"
                label-class="data-label"
                v-model="txtPermission.model"
              />
            </div>
          </div>
        </div>
      </div>
        
    </validation-observer>
  </span>
</template>

<script>
import CustomInput from 'CustomInput'
import CustomInputDisplay from 'CustomInputDisplay'
import ActionButton from 'ActionButton'
import SectionTitle from '@/components/common/SectionTitle'
import interfacesServices from '@/modules/interfaces/api'

export default {
  name: 'InterfacesManager',
  components: {
    CustomInput,
    CustomInputDisplay,
    ActionButton,
    SectionTitle,
  },
  data: () => ({
     id: null,
     txtApplication: {
      label: "Aplicación:",
      type: "text",
      disabled: true,
      model: null,
    },
    txtModule: {
      label: "Módulo:",
      type: "text",
      disabled: true,
      model: null,
    },
    txtName: {
      label: "Nombre:",
      type: "text",
      errorMsg: "El Nombre es requerido.",
      model: null,
    },
    txtDescription: {
      label: "Descripción:",
      type: "text",
      errorMsg: "La descripción es requerida.",
      model: null,
    },
    txtDetail: {
      label: "Detalle:",
      type: "text",
      errorMsg: "El detalle es requerido.",
      model: null,
    },
    txtOrder: {
      label: "Orden:",
      type: "number",
      errorMsg: "El orden es requerido.",
      model: null,
    },
    txtUrl: {
      label: "URL:",
      type: "text",
      disabled: true,
      visible: false,
      model: null,
    },
    txtIcon: {
      label: "Icono:",
      type: "text",
      disabled: true,
      visible: false,
      model: null,
    },
     txtPermission: {
      label: "Permiso:",
      type: "text",
      disabled: true,
      visible: false,
      model: null,
    },
  }),
  mounted() {
    this.getInterface();
  },
  methods: {
    async getInterface() {
      const interfaceId = this.$route.params.interfaceId;

      await interfacesServices.getById(interfaceId).then(res => {
          const navMenu = res.data;

          this.id = navMenu.id;
          this.txtApplication.model = navMenu.applicationName;
          this.txtModule.model = navMenu.moduleName;
          this.txtName.model = navMenu.name;
          this.txtDescription.model = navMenu.description;
          this.txtDetail.model = navMenu.detail;
          this.txtOrder.model = navMenu.order;
          this.txtUrl.model = navMenu.url;
          this.txtIcon.model = navMenu.icon;
          this.txtPermission.model = navMenu.permissionName;
        });
    },
    async onClickSaveHandler() {
      var isValid = await this.$refs.interfaceRef.validate();
      
      if (!isValid) {
        this.Toast('Alerta','Favor de completar la información solicitada para continuar.','error')
        return;
      }

      const model = { 
        id: this.id,
        name: this.txtName.model,
        description: this.txtDescription.model,
        detail: this.txtDetail.model,
        order: parseInt(this.txtOrder.model),
      };

      await interfacesServices.save(model).then(res => {
        if (res.status === 200) {
          this.Toast('Exito','La navegación ha sido guardada exitosamente.','success');
        }
      });
    },
    onClickReturnHandler() {
      this.$router.go(-1);
    }
  },
}
</script>